export default {
  computed: {
    uniqueId() {
      return `${this.$options.name}_${this._uid}`;
    },
  },
};
